import { Routes, Route } from 'react-router-dom'
import { Header } from '@/components/header'
import { Footer } from '@/components/footer'
import HomePage from '@/pages/HomePage'
import AboutPage from '@/pages/AboutPage'
import ContactPage from '@/pages/ContactPage'
import DataProtectionPage from '@/pages/DataProtectionPage'
import ImprintPage from '@/pages/ImprintPage'
import HelpNeededPage from '@/pages/HelpNeededPage'
import AppsPage from '@/pages/AppsPage'
import MembershipPage from '@/pages/MembershipPage'
import NotFoundPage from '@/pages/NotFoundPage'

function App() {
  return (
    <div className="min-h-screen dark:bg-slate-900 bg-slate-50">
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/privacy" element={<DataProtectionPage />} />
        <Route path="/imprint" element={<ImprintPage />} />
        <Route path="/mitmachen" element={<HelpNeededPage />} />
        <Route path="/apps" element={<AppsPage />} />
        <Route path="/verein-beitreten" element={<MembershipPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <Footer />
    </div>
  )
}

export default App
